import { Controller } from "@hotwired/stimulus"

function debounce(callback, delay) {
  let timeoutId = null

  const debounced = (...args) => {
    if (timeoutId) {
      clearTimeout(timeoutId)
    }

    timeoutId = setTimeout(() => {
      timeoutId = null
      callback(...args)
    }, delay)
  }

  debounced.cancel = () => {
    if (timeoutId) {
      clearTimeout(timeoutId)
      timeoutId = null
    }
  }

  return debounced
}

export default class extends Controller {
  static targets = ["form"]
  static values = {
    searchDelay: { type: Number, default: 300 }
  }

  connect() {
    this.debouncedSubmit = debounce(() => {
      this.submit()
    }, this.searchDelayValue)
  }

  disconnect() {
    this.debouncedSubmit?.cancel()
  }

  submitWithDebounce() {
    this.debouncedSubmit()
  }

  submitImmediately() {
    this.debouncedSubmit?.cancel()
    this.submit()
  }

  submitOnChange() {
    this.submitImmediately()
  }

  submit() {
    if (this.hasFormTarget) {
      this.formTarget.requestSubmit()
    }
  }
}
